import { useVenuesMasterdataQuery } from "@/features/masterdata/queries/venues-masterdata-query";

export function useVenuesMasterdata() {
  const query = useVenuesMasterdataQuery();

  const venues = computed(() => query.data.value || []);

  function getVenueByCode(code: string) {
    return venues.value.find((venue) => venue.code === code);
  }

  function getVenueNameByCode(code: string) {
    return getVenueByCode(code)?.name ?? code;
  }

  function getVenueNamesByCodes(codes: string[]) {
    return codes.map(getVenueNameByCode).join(", ");
  }

  return {
    venues,
    getVenueByCode,
    getVenueNameByCode,
    getVenueNamesByCodes,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
